import { GalimardIngredient } from "./GalimardIngredient";

export const GalimardNoteDeTete: GalimardIngredient[] = [
  {
    name: "ANANAS",
    galimardReference: "901",
    description: {
      fr: "Un ananas bien mûr, juteux et acidulé, à la douceur exotique. Il ouvre le parfum sur une note gaie et ensoleillée.",
      en: "Ripe, juicy pineapple, tangy with a tropical sweetness. It opens the perfume on a cheerful, sunny note.",
    },
    advice: `Elle évoque des sentiments de positivité et de bonne humeur.`,
    icon: "ananas",
  },
  {
    name: "ANIS",
    galimardReference: "??",
    description: {
      fr: "Frais et sucré à la fois, l’anis rappelle la réglisse et le fenouil. Il glisse dans l’ouverture une touche aromatique inattendue.",
      en: "Both fresh and sweet, anise recalls licorice and fennel. It slips an unexpected aromatic twist into the opening.",
    },
    advice: ``,
    icon: "anis",
  },
  {
    name: "BERGAMOTE",
    galimardReference: "676",
    description: {
      fr: "Zestée, acidulée et légèrement amère, la bergamote cache aussi une délicate facette fleurie. Sa fraîcheur lumineuse en fait l’une des notes de tête les plus utilisées.",
      en: "Zesty, tangy and slightly bitter, bergamot also hides a delicate floral facet. Its bright freshness makes it one of the most widely used top notes.",
    },
    advice: `Elle crée une impression de pureté et de vivacité`,
    icon: "bergamote",
  },
  {
    name: "BERGAMOTE VERTE",
    galimardReference: "602",
    description: {
      fr: "Une bergamote plus verte et plus acidulée, avec l’amertume des feuilles d’agrumes froissées, pour un départ net et tonique.",
      en: "A greener, tarter bergamot with the bitterness of crushed citrus leaves, for a crisp, invigorating start.",
    },
    advice: `Elle est souvent associée à d'autres notes florales, comme le la rose.`,
    icon: "bergamote-verte",
  },
  {
    name: "BOUTON DE ROSE",
    displayName: {
      fr: "Bouton de Rose",
      en: "",
    },
    galimardReference: "677",
    description: {
      fr: "Une rose encore en bouton, fraîche, verte et perlée de rosée, plus légère qu’une rose épanouie. Elle pose dès l’ouverture une touche florale délicate.",
      en: "A rose still in bud: fresh, green and dewy, lighter than a rose in full bloom. It adds a delicate floral touch right from the start.",
    },
    advice: `Elle peut être portée au quotidien pour une touche de sophistication.`,
    icon: `bouton-de-rose`,
  },
  {
    name: "CARDAMOME",
    galimardReference: "970",
    description: {
      fr: "Une épice fraîche plutôt que brûlante, aux accents citronnés et légèrement camphrés. En tête, la cardamome dessine un relief aromatique raffiné.",
      en: "A cool rather than fiery spice, with lemony, slightly camphor-like facets. At the top, cardamom adds a refined aromatic lift.",
    },
    advice: `Elle peut être associée à des notes florales, fruitées ou boisées.`,
    icon: "cardamome",
  },
  {
    name: "CERISE",
    galimardReference: "133",
    description: {
      fr: "Une cerise bien mûre, pulpeuse et sucrée, avec une pointe acidulée de griotte et un soupçon d’amande. Un départ fruité, gourmand et joyeux.",
      en: "A ripe, plump cherry, sweet with a sour-cherry tang and a hint of almond. A joyful, gourmand fruity opening.",
    },
    displayName: {
      fr: "Cerise",
      en: "Cherry",
    },
    icon: "cerise",
  },
  {
    name: "CITRON AMER",
    displayName: {
      fr: "Citron Amer",
      en: "",
    },
    galimardReference: "678",
    description: {
      fr: "Un citron vif et piquant, avec l’amertume de la peau blanche du fruit. Il éclaire l’ouverture d’un éclat franc et pétillant.",
      en: "Sharp, tangy lemon with the bitterness of the white pith. It lights up the opening with a crisp, fizzy brightness.",
    },
    advice: `La fragrance citron amer est idéale pour les personnes qui recherchent une fragrance fraîche et énergisante.`,
    icon: "citron-amer",
  },
  {
    name: "CITRON DOUX",
    galimardReference: "679",
    description: {
      fr: "Un citron rond et juteux, moins acide, qui évoque une citronnade sucrée. Sa fraîcheur tendre arrondit les agrumes plus vifs.",
      en: "A rounder, juicier lemon with less bite, like sweetened lemonade. Its gentle freshness softens sharper citrus notes.",
    },
    advice: `Le citron doux est une fragrance polyvalente qui peut être portée en toute occasion.`,
    icon: "citron-doux",
  },
  {
    name: "CITRON ZESTE",
    galimardReference: "680",
    description: {
      fr: "L’écorce de citron fraîchement râpée, vive, acidulée et légèrement huileuse. Une note lumineuse et tonique pour réveiller le départ.",
      en: "Freshly grated lemon peel, zingy, tart and slightly oily. A bright, energizing note to wake up the opening.",
    },
    advice: `Le zeste de citron est une note versatile, unisexes qui se caractérise par son acidité.`,
    icon: "citron-zeste",
  },
  {
    name: "COMPLEXE VERT",
    galimardReference: "605",
    description: {
      fr: "Un accord vert dense mêlant tiges coupées, bourgeons et sève, à l’amertume franche. Il installe en ouverture une fraîcheur végétale marquée.",
      en: "A dense green accord of cut stems, buds and sap, with a frank bitterness. It sets a bold leafy freshness at the opening.",
    },
    advice: ``,
    icon: "complexe-vert",
  },
  {
    name: "CONCOMBRE",
    galimardReference: "954",
    description: {
      fr: "Croquant et désaltérant, le concombre apporte en tête une fraîcheur aqueuse et légèrement verte. Une petite dose suffit à alléger un accord.",
      en: "Crisp and thirst-quenching, cucumber brings a watery, slightly green coolness to the top. A small amount is enough to lighten a blend.",
    },
    advice: ``,
    icon: "concombre",
  },
  {
    name: "FEUILLES VERTES",
    galimardReference: "606",
    description: {
      fr: "L’odeur de feuilles fraîchement froissées entre les doigts, verte, vive, presque piquante. Elle signe un départ printanier et plein de vie.",
      en: "The smell of leaves freshly crushed between your fingers, green, lively, almost sharp. It makes for a vivid, springlike opening.",
    },
    advice: ``,
    icon: "feuilles-vertes",
  },
  {
    name: "FLEUR ORANGER",
    displayName: {
      fr: "Fleur d'Oranger Murcia",
      en: "",
    },
    galimardReference: "347",
    description: {
      fr: "La fleur d’oranger, blanche, miellée et lumineuse, avec une fraîcheur légèrement verte. Elle fait entrer le soleil dès les premières notes.",
      en: "Orange blossom, white, honeyed and radiant, with a slightly green freshness. It lets the sunshine in from the very first notes.",
    },
    advice: ``,
    icon: "fleur-oranger",
  },
  {
    name: "FLORALE FRAICHE",
    displayName: {
      fr: "Florale Fraîche",
      en: "",
    },
    galimardReference: "607",
    description: {
      fr: "Un bouquet de fleurs légères, aérien et légèrement vert, sans aucune lourdeur. Une entrée en matière florale, fraîche et transparente.",
      en: "An airy bouquet of light flowers with a soft green edge and no heaviness. A fresh, sheer floral way to begin.",
    },
    advice: ``,
    icon: "florale-fraiche",
  },
  {
    name: "FRUIT DE BERGAMOTE",
    displayName: {
      fr: "Fruit de Bergamote",
      en: "",
    },
    galimardReference: "608",
    description: {
      fr: "La bergamote côté fruit, plus juteuse et plus ronde, avec une acidité douce et un zeste pétillant. Elle illumine les premières minutes d’un éclat frais et fruité.",
      en: "Bergamot at its fruitiest: juicier and rounder, with a gentle tang and a sparkling zest. It brightens the first minutes with a fresh, fruity glow.",
    },
    advice: ``,
    icon: "fruit-bergamote",
  },
  {
    name: "FRUITS DE CASSIS",
    displayName: {
      fr: "Fruit de Cassis",
      en: "",
    },
    galimardReference: "505",
    description: {
      fr: "Des baies de cassis acidulées et juteuses, relevées par la verdeur piquante du bourgeon. Elles apportent en tête un fruité vif, presque sauvage.",
      en: "Tart, juicy blackcurrants with the sharp green bite of the bud. They add a lively, almost wild fruitiness to the top.",
    },
    advice: ``,
    icon: "fruits-decassis",
  },
  {
    name: "FRUITS VERTS",
    galimardReference: "609",
    description: {
      fr: "Pomme verte, poire à peine mûre et fruits croquants, à l’acidité fraîche. Une ouverture fruitée légère, plus acidulée que sucrée.",
      en: "Green apple, barely ripe pear and other crisp fruit, with a fresh tartness. A light fruity opening, more tangy than sweet.",
    },
    advice: ``,
    icon: "fruits-verts",
  },
  {
    name: "GALBANUM VERT",
    galimardReference: "683",
    description: {
      fr: "Une résine à l’odeur verte, intense et amère, qui évoque la tige coupée et la cosse de petit pois. Très puissante, elle se dose avec parcimonie pour donner du mordant.",
      en: "A resin with an intense, bitter green smell of snapped stems and pea pods. Very powerful, it is used sparingly to add bite.",
    },
    advice: ``,
    icon: "galbanum-vert",
  },
  {
    name: "GERANIUM SAUVAGE",
    displayName: {
      fr: "Géranium Sauvage",
      en: "",
    },
    galimardReference: "610",
    description: {
      fr: "Un géranium plus sauvage et herbacé, rosé, mentholé et légèrement poivré. En tête, il apporte une fraîcheur aromatique au caractère affirmé.",
      en: "A wilder, more herbal geranium, rosy, minty and slightly peppery. At the top, it adds an aromatic freshness with real character.",
    },
    advice: ``,
    icon: "geranium-sauvage",
  },
  {
    name: "HERBE FRAICHE",
    displayName: {
      fr: "Herbe Fraîche",
      en: "",
    },
    galimardReference: "612",
    description: {
      fr: "L’odeur d’une pelouse fraîchement tondue, verte, gorgée de sève et légèrement acidulée. Elle évoque dès l’ouverture un matin à la campagne.",
      en: "The smell of a freshly mown lawn, green, full of sap and slightly tangy. From the opening, it evokes a morning in the countryside.",
    },
    advice: ``,
    icon: "herbe-fraiche",
  },
  {
    name: "JASMIN ORIENTAL",
    galimardReference: "614",
    description: {
      fr: "Un jasmin riche et capiteux, aux accents miellés et légèrement épicés. Placé en tête, il annonce d’emblée un parfum floral chaleureux et sensuel.",
      en: "A rich, heady jasmine with honeyed, slightly spicy accents. Placed at the top, it heralds a warm, sensual floral perfume from the outset.",
    },
    advice: ``,
    icon: "jasmin-oriental",
  },
  {
    name: "LAVANDE DES ALPES",
    displayName: {
      fr: "Lavande des Alpes",
      en: "",
    },
    galimardReference: "697",
    description: {
      fr: "Une lavande d’altitude, fine et florale, à la fraîcheur douce et propre. Elle apporte en tête une note aromatique claire, classique et lumineuse.",
      en: "A fine, floral high-altitude lavender with a soft, clean freshness. It brings a clear aromatic note to the top, classic yet bright.",
    },
    advice: ``,
    icon: "lavande-des-alpes",
  },
  {
    name: "LAVANDE SAUVAGE",
    galimardReference: "615",
    description: {
      fr: "Une lavande plus rustique et herbacée, aux accents camphrés. Sa fraîcheur aromatique franche évoque, dès le départ, les collines sèches du Sud.",
      en: "A more rustic, herbal lavender with camphor-like accents. Its frank aromatic freshness recalls the dry hills of the South from the very start.",
    },
    advice: ``,
    icon: "lavande-sauvage",
  },
  {
    name: "LIMETTE VERTE",
    galimardReference: "686",
    description: {
      fr: "Le citron vert dans toute sa vivacité, acidulé, zesté, à l’amertume légère. Une fraîcheur pétillante pour commencer, comme une boisson glacée en été.",
      en: "Lime at its liveliest, tart, zesty and slightly bitter. A fizzy freshness to begin with, like an iced drink in summer.",
    },
    advice: ``,
    icon: "limette-verte",
  },
  {
    name: "LITCHEE",
    galimardReference: "925",
    description: {
      fr: "Le litchi, juteux et sucré, avec une nuance délicatement rosée et une pointe acidulée. En tête, il apporte une douceur fruitée et exotique.",
      en: "Lychee, juicy and sweet, with a delicate rosy nuance and a hint of tartness. At the top, it brings an exotic fruity sweetness.",
    },
    advice: ``,
    icon: "litchee",
  },
  {
    name: "LOTUS",
    galimardReference: "921",
    description: {
      fr: "Une fleur aquatique, légère et transparente, entre fraîcheur de l’eau et douceur poudrée. Le lotus pose en tête une note florale sereine et lumineuse.",
      en: "A watery, sheer flower, poised between cool water and soft powder. Lotus adds a serene, luminous floral note at the top.",
    },
    advice: ``,
    icon: "lotus",
  },
  {
    name: "MANDARINE",
    galimardReference: "687",
    description: {
      fr: "La mandarine, juteuse, sucrée et pétillante, plus douce que l’orange. Un éclat fruité, gai et lumineux, pour ouvrir le parfum.",
      en: "Mandarin, juicy, sweet and sparkling, gentler than orange. A cheerful, sunny burst of fruit to open the perfume.",
    },
    advice: ``,
    icon: "mandarine",
  },
  {
    name: "MANDARINE DOUCE",
    galimardReference: "166",
    description: {
      fr: "Une mandarine encore plus ronde et sucrée, presque confite, avec très peu d’acidité. Elle apporte en tête une douceur fruitée gourmande.",
      en: "An even rounder, sweeter mandarin, almost candied, with very little tartness. It adds a soft, gourmand fruitiness to the top.",
    },
    advice: ``,
    icon: "mandarine-douce",
  },
  {
    name: "MANGUE",
    galimardReference: "908",
    description: {
      fr: "Une mangue mûre, fondante et sucrée, avec une pointe résineuse qui signe son exotisme. Elle colore l’ouverture d’une douceur fruitée et solaire.",
      en: "Ripe, melting, sweet mango with a resinous hint that marks its exotic character. It colors the opening with a sunny fruitiness.",
    },
    advice: ``,
    icon: "mangue",
  },
  {
    name: "NOTE HESPERIDEE",
    displayName: {
      fr: "Note Hespéridée",
      en: "",
    },
    galimardReference: "688",
    description: {
      fr: "Les hespéridés, c’est ainsi que les parfumeurs nomment les agrumes. Cet accord mêle citron, orange et bergamote pour un départ pétillant, façon eau de Cologne.",
      en: "Hesperidic is the perfumer’s word for citrus. This blend of lemon, orange and bergamot gives a sparkling, eau de Cologne-style start.",
    },
    advice: ``,
    icon: "note-hesperidee",
  },
  {
    name: "NOTE VERTE",
    galimardReference: "617",
    description: {
      fr: "Une verdeur légère et aérienne, comme une jeune pousse ou une tige fraîche. Elle apporte une touche végétale discrète qui allège le départ.",
      en: "A light, airy greenness, like a young shoot or a fresh stem. It adds a discreet green touch that lightens the opening.",
    },
    advice: ``,
    icon: "note-verte",
  },
  {
    name: "ORANGER",
    galimardReference: "619",
    description: {
      fr: "L’oranger tout entier, avec l’orange juteuse, ses feuilles vertes et une pointe de fleur. Une ouverture ensoleillée, fruitée et légèrement amère.",
      en: "The whole orange tree: juicy orange, green leaves and a hint of blossom. A sunny opening, fruity with a slightly bitter edge.",
    },
    advice: ``,
    icon: "oranger",
  },
  {
    name: "PAMPLEMOUSSE",
    galimardReference: "122",
    description: {
      fr: "Le pamplemousse, acidulé et légèrement amer, à la fraîcheur juteuse et pétillante. Il insuffle au départ du tonus et de l’éclat.",
      en: "Grapefruit, tangy and slightly bitter, with a juicy, sparkling freshness. It gives the opening energy and brightness.",
    },
    advice: ``,
    icon: "pamplemousse",
  },
  {
    name: "PECHE BLANCHE",
    displayName: {
      fr: "Pêche blanche",
      en: "",
    },
    galimardReference: "912",
    description: {
      fr: "Une pêche blanche juteuse, à la peau veloutée et à la chair tendre et sucrée. Elle apporte en tête un fruité doux, presque lacté.",
      en: "Juicy white peach with velvety skin and tender, sweet flesh. It brings a soft, almost creamy fruitiness to the top.",
    },
    advice: ``,
    icon: "peche-blanche",
  },
  {
    name: "POIRE",
    displayName: {
      fr: "Poire sorbet",
      en: "",
    },
    galimardReference: "956",
    description: {
      fr: "Une poire juteuse servie en sorbet, fraîche, sucrée et presque givrée. Elle rafraîchit le départ d’une note fruitée gourmande.",
      en: "Juicy pear served as a sorbet, cool, sweet and almost frosty. It cools the opening with a gourmand fruity note.",
    },
    advice: ``,
    icon: "poire",
  },
  {
    name: "POIVRE ROSE",
    galimardReference: "578",
    description: {
      fr: "Les baies roses, poivrées sans brûler, avec une facette fruitée et légèrement résineuse. Elles donnent du piquant et du relief à l’ouverture.",
      en: "Pink peppercorns, peppery without the heat, with a fruity, slightly resinous facet. They add sparkle and bite to the opening.",
    },
    advice: ``,
    icon: "poivre-rose",
  },
  {
    name: "ROSE DE MAI",
    displayName: {
      fr: "Rose de mai",
      en: "",
    },
    galimardReference: "622",
    description: {
      fr: "La rose de mai est la rose centifolia que l’on cueille en mai dans le pays de Grasse. Fraîche, miellée et délicatement poudrée, elle fleurit dès l’ouverture.",
      en: "May rose is the centifolia rose picked around Grasse every May. Fresh, honeyed and softly powdery, it blooms from the opening onward.",
    },
    advice: ``,
    // prompt: "bouquet of Rosa Centifolia, detailed, white background"
    icon: "rose-de-mai",
  },
  {
    name: "ROSE FRUITEE",
    displayName: {
      fr: "Rose Fruitée",
      en: "",
    },
    galimardReference: "623",
    description: {
      fr: "Une rose gourmande aux accents de fruits rouges et de litchi, fraîche et juteuse. Elle ouvre le bal avec un floral gai et coloré.",
      en: "A playful rose with hints of red berries and lychee, fresh and juicy. It kicks off the perfume with a bright, colorful floral touch.",
    },
    advice: ``,
    icon: "rose-fruitee",
  },
  {
    name: "SAUGE SCLAREE",
    displayName: {
      fr: "Sauge Sclarée",
      en: "",
    },
    galimardReference: "722",
    description: {
      fr: "Une plante aromatique aux facettes herbacées et légèrement ambrées, qui rappellent le thé. En tête, la sauge sclarée offre une fraîcheur raffinée, un peu musquée.",
      en: "An aromatic herb with herbal, slightly ambery facets reminiscent of tea. At the top, clary sage offers a refined freshness with a soft musky edge.",
    },
    advice: ``,
    icon: "sauge-sclaree",
  },
  {
    name: "SECRET DU PARFUMEUR",
    displayName: {
      fr: "Secret du parfumeur",
      en: "",
    },
    galimardReference: "749",
    description: {
      fr: "Un accord dont la formule reste secrète, souvent proposé en touche finale pour donner de l’éclat et de la diffusion au parfum. Puissant, il se dose avec légèreté.",
      en: "An accord whose formula is kept secret, often suggested as a finishing touch to give the perfume radiance and projection. It is strong, so use a light hand.",
    },
    advice: ``,
    // prompt: "secret scent fragrance, detailed, white background"
    icon: "secret-du-parfumeur",
  },
  {
    name: "POMME",
    galimardReference: "??",
    description: {
      fr: "Une pomme croquante et juteuse, entre l’acidité du fruit vert et la douceur du fruit mûr. Une note de tête fraîche et familière, que tout le monde reconnaît.",
      en: "Crisp, juicy apple, between the tartness of a green apple and the sweetness of a ripe one. A fresh, familiar top note that everyone recognizes.",
    },
    advice: ``,
    icon: "pomme",
  },
  {
    name: "THE ANGLAIS",
    displayName: {
      fr: "Thé Anglais",
      en: "",
    },
    galimardReference: "931",
    description: {
      fr: "Un thé noir à l’anglaise, aux accents de feuilles séchées, un peu tanniques et boisées. Il donne à l’ouverture une élégance feutrée.",
      en: "Black tea, English style, with notes of dried leaves, a gentle tannic edge and a hint of wood. It brings a soft, refined warmth to the top.",
    },
    advice: ``,
    icon: "the-anglais",
  },
  {
    name: "THE VERT",
    displayName: {
      fr: "Thé Vert",
      en: "",
    },
    galimardReference: "932",
    description: {
      fr: "Un thé vert léger et transparent, frais, un peu amer et délicatement floral. En tête, il laisse une impression de clarté et de calme.",
      en: "Light, sheer green tea, fresh, slightly bitter and delicately floral. At the top, it leaves a clear, calm impression.",
    },
    advice: ``,
    // prompt: "green tea, glass cup, detailed, white background"
    icon: "the-vert",
  },
  {
    name: "TOMATE",
    galimardReference: "916",
    description: {
      fr: "L’odeur verte et piquante des feuilles de tomate, un peu terreuse, comme au potager en plein été. Une fraîcheur végétale originale, pour un départ qui surprend.",
      en: "The sharp green smell of tomato leaves, slightly earthy, like a vegetable garden in midsummer. An unusual leafy freshness for a surprising opening.",
    },
    advice: ``,
    // prompt: "sliced tomato on a small wooden plank, detailed, white background"
    icon: "tomate",
  },
  {
    name: "VERVEINE",
    galimardReference: "689",
    description: {
      fr: "La verveine citronnée, herbacée et zestée, plus douce qu’un citron. Elle parfume l’ouverture d’une fraîcheur claire, qui évoque les jardins en été.",
      en: "Lemon verbena, herbal and zesty, softer than lemon itself. It scents the opening with a clear freshness that recalls summer gardens.",
    },
    advice: ``,
    // prompt: "verbena verveine, detailed, white background"
    icon: "verveine",
  },
  {
    name: "YUZU",
    galimardReference: "968",
    description: {
      fr: "Agrume emblématique du Japon, le yuzu est acidulé et parfumé, entre pamplemousse et mandarine, avec une touche florale. Une ouverture fraîche, vive et délicate.",
      en: "A citrus fruit emblematic of Japan, yuzu is tart and fragrant, somewhere between grapefruit and mandarin, with a floral touch. A fresh, lively and delicate opening.",
    },
    advice: ``,
    icon: "yuzu",
  },
  {
    name: "FRAMBOISE",
    displayName: {
      fr: "Framboise",
      en: "Raspberry",
    },
    galimardReference: "765",
    description: {
      fr: "Une framboise juteuse, sucrée et acidulée, avec une nuance florale qui rappelle la violette. Elle met de la couleur et de la gourmandise dans l’ouverture.",
      en: "Juicy raspberry, sweet and tart, with a floral nuance reminiscent of violet. It brings color and a gourmand touch to the opening.",
    },
    icon: "framboise",
  },
  {
    name: "MENTHE",
    displayName: {
      fr: "Menthe",
      en: "Mint",
    },
    galimardReference: "764",
    description: {
      fr: "La menthe fraîchement cueillie, vive et aromatique, avec une pointe verte et légèrement sucrée. Quelques gouttes suffisent à donner un souffle glacé au départ.",
      en: "Freshly picked mint, bright and aromatic, with a green, slightly sweet edge. Just a few drops give the opening an icy breath.",
    },
    icon: "menthe",
  },
];
